const Apexchart = {
    settings(id = "apexchart", showToolbar = true) {
        return {
            chart: {
                id: id,
                type: "line",
                toolbar: {
                    show: showToolbar,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                    },
                    autoSelected: 'zoom'
                },
                animations: {
                    enabled: false,
                    animateGradually: {
                        enabled: false
                    },
                    dynamicAnimation: {
                        enabled: false
                    }
                }
            },
            theme: {
                palette: "palette3"
            },
            xaxis: {
                type: "category",
                labels: {
                    show: true,
                    rotate: -70,
                    rotateAlways: false,
                    hideOverlappingLabels: true,
                    showDuplicates: false,
                    trim: false,
                    minHeight: undefined,
                    maxHeight: 120,
                    style: {
                        colors: [],
                        fontSize: '12px',
                        fontFamily: 'Rubik, arial',
                        fontWeight: 400,
                        cssClass: 'apexcharts-xaxis-label',
                    },
                    offsetX: 0,
                    offsetY: 0,
                    format: undefined,
                    formatter: undefined,
                    datetimeUTC: false,
                    datetimeFormatter: {
                        year: 'yyyy',
                        month: "MMM 'yy",
                        day: 'dd MMM',
                        hour: 'HH:mm',
                    }
                },
                tickAmount: 10
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                curve: "straight",
                lineCap: "butt",
                width: 2,
                dashArray: 0
            },
            tooltip: {
                x: { format: "dd MMM HH:mm" }
            }
        }
    }
}


export default Apexchart;